import { isMobile } from '../../services';
import { PreviewSlider as Mobile } from './mobile';
import { PreviewSlider as Web } from './web';

export const PreviewSlider = isMobile ? Mobile : Web;
